module.exports = __webpack_public_path__ + "static/media/25114980_1545557718827197_1306570868_n.2a8f8c18.jpg";